import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Grid, Typography, Container } from "@material-ui/core";

import Carousel, { consts } from "react-elastic-carousel";

import ImageWithPlacholder from "./ImageWithPlaceholder";
import CalgaryTowerImage from "../images/calgarytower.webp";

function CaseStudy(props) {
  return (
    <SectionWrapper disableGutters maxWidth="lg">
      <Wrapper
        component="section"
        id="caseStudy"
        container
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item xs={12} sm={12} md={5}>
          <Typography variant="h5">CALGARY TOWER CASE STUDY</Typography>
          <Typography variant="body1">
            A fully integrated, privately held real estate company engaged MillarForan to secure
            financing for this iconic Calgary landmark, the Calgary Tower. Through its process,
            MillarForan identified lenders well-suited to the requirements of the subject property
            while structuring a financing solution that met the borrower’s needs.
          </Typography>
          <a class="primary-btn" href="/mIllarforan_announcement_calgary_tower.pdf" target="_blank">
            Download PDF
          </a>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <img
            src={CalgaryTowerImage}
            className="main-image"
            alt="Millar Forran - Calgary Tower Case Study"
          />
        </Grid>
      </Wrapper>
    </SectionWrapper>
  );
}

const SectionWrapper = styled(Container)`
  position: relative;
  padding: 0;
  background-color: #f2f2f2;
  padding: 4rem 0rem;
  ${props => props.theme.breakpoints.up("sm")} {
    padding: 4rem 3rem;
  }
  ${props => props.theme.breakpoints.up("md")} {
    padding: 4rem 5rem;
  }
  width: 100%;
  max-width: 100%;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0px;
    width: 100vw;
    height: 100%;
    background-color: #f2f2f2;
    z-index: -1;
  }
  .primary-btn {
    margin-top: 3rem;
    display: inline-block;
    padding: 1rem 2rem;
    background: ${props => props.theme.palette.primary.main};
    color: ${props => props.theme.palette.common.white};
    border-radius: 0;
    border: 1px solid ${props => props.theme.palette.primary.main};
    transition: all 0.3s ease-in-out;
    text-decoration: none;
    margin-bottom: 3rem;
    font-family: "Trebuchet MS", sans-serif;
    &:hover {
      background: ${props => props.theme.palette.common.white};
      color: ${props => props.theme.palette.primary.main};
    }
  }
`;

const Wrapper = styled(Grid)`
  padding: 2rem 1rem 2rem;
  max-width: 1280px;
  margin: 0 auto;

  background-color: #f2f2f2;
  ${props => props.theme.breakpoints.down("sm")} {
    /* padding-top: initial;
    padding-left: 1rem;
    padding-right: 1rem; */
    /* padding-bottom: 1rem; */
  }
  ${props => props.theme.breakpoints.up("sm")} {
    /* padding-top: initial;
    padding-left: 1rem;
    padding-right: 1rem; */
    padding: initial;
  }
  ${props => props.theme.breakpoints.up("lg")} {
    /* padding: 6rem 139px 4rem; */
    min-height: 638px;
  }

  ${props => props.theme.breakpoints.up("xl")} {
  }

  h5 {
    padding-top: 0rem;
    padding-bottom: 1.5rem;
    ${props => props.theme.breakpoints.up("sm")} {
      padding-top: 0rem;
    }
  }

  img.main-image {
    width: 100%;
    height: auto;
    max-width: 100%;
    ${props => props.theme.breakpoints.up("sm")} {
      width: 100%;
      max-width: 100%;
      height: auto;
    }
    ${props => props.theme.breakpoints.up("md")} {
    }
    ${props => props.theme.breakpoints.up("lg")} {
      padding-right: 1rem;
      width: 100%;
      max-width: 100%;
      height: auto;
    }
    ${props => props.theme.breakpoints.up("xl")} {
    }
  }
`;

CaseStudy.propTypes = {};

export default CaseStudy;
